//
// TimeAxisOptions.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./NumericAxisOptions";
import "./TimeIntervalEnum";
import "./AxisTickValueFitPolicy";
import "./AxisTickValueRotation";
import "./AxisIncludeRangeEntry";

var TimeAxisOptions = createModule("gtl::TimeAxisOptions", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::NumericAxisOptions"], EventDispatcher, [
    ,
    {
        tickValueFormat: 7,
        minorTickInterval: 4,
        includeRanges: [1],
        splitTickValue: 2,
        interval: 4,
        tickValueFitPolicy: 4,
        intervalMultiplier: 4,
        tickValueRotation: 4,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default TimeAxisOptions;
